import React, { useState } from 'react';
import Navbar from '../../../components/navbar'
import Footer from '../../../components/footer';
import { FaPencilAlt, FaSearch, FaComments, FaCommentDots } from 'react-icons/fa'

export default function HomeEn() {
  const [showAsk1, setShowAsk1] = useState(false)
  const [showAsk2, setShowAsk2] = useState(false)


  return (
    <div>
      <Navbar lang={'en'} />
      <main className='flex mt-40 flex-col '>
        <section className='bg-danger mb-4 bg-opacity-15'>
          <p className='text-warning font-medium text-lg lg:w-4/6 md:w-5/6 w-11/12 m-auto p-4 text-center'> 
            Dear reporter, we inform you that the Mig-PLUS Ombudsman Channel is in transition. 
            We recommend that new reports be made directly to the Cargill Ethics Open Line (EOL), 
            through the link <a href="https://cargill.navexone.com/intake/" target="_blank" rel="noopener noreferrer" className='font-bold '>https://cargill.navexone.com/intake/</a> or by phone <b>0800-000-2756</b>.
            If you have any questions or difficulty accessing the new channel, please contact the Mig-PLUS Ethics Committee to obtain 
            proper support. Sincerely!
          </p>
        </section>
        <section className='lg:w-4/6 md:w-5/6 w-11/12 m-auto'>
          <div className='gap-2 flex flex-col text-secondary font-medium'>
            <h1 className='text-primary flex items-center gap-4 text-2xl font-bold mb-8'><FaComments size={`2.5rem`} /> Ombudsman</h1>
            <p>Welcome</p>
            <p>This is an exclusive Mig-PLUS channel for secure communication about breaches of ethics, denouncements of internal and external irregularities, guaranteeing the anonymity of the reporter and the confidentiality of the issues dealt with.</p>
            <p>Retaliation will not be accepted against anyone who, in good faith, reports any breach of conduct.</p>
            <p>When using these channels, have an ethical attitude. Act responsibly!</p>
            <p><b>Consumer:</b> for questions, requests, compliments, suggestions or complaints about the products, use our <b>SAC: 0800-97-96876</b> or <b>+ 55 (54) 3347-3100</b>.</p>
          </div>
        </section>
        <section className='mt-12 mb-12 bg-background'>
          <div className='lg:w-4/6 md:w-5/6 w-11/12 m-auto p-8 flex flex-col'>
            <h2 className='text-center text-primary text-2xl font-bold'>Choose one of the options below</h2>
            <div className='flex gap-8 justify-evenly mt-8 flex-col md:flex-row'>
              <span className='opacity-50 cursor-not-allowed bg-white px-16 py-8 border text-primary rounded-lg font-bold text-xl uppercase flex gap-4 select-none'>
                <FaPencilAlt size={'2rem'}/>
                Make report
              </span>
              <a className='bg-white px-16 py-8 border text-primary shadow-xl rounded-lg font-bold text-xl hover:bg-primary hover:text-white uppercase flex gap-4' href="/en/follow">
                <FaSearch size={'2rem'}/>
                follow report
              </a>
            </div>
          </div>
        </section>
        <section className='lg:w-4/6 md:w-5/6 w-11/12 m-auto'>
          <div>
            <h1 className='text-4xl flex items-center gap-4 text-primary mb-8'><FaCommentDots/> Common Questions</h1>
            <div className='rounded-md border border-background mb-8 shadow-md' >
              <button onClick={() => setShowAsk1(!showAsk1)} className='text-2xl bg-background w-full p-4 text-start text-secondary rounded-t-md'>How does the Ombudsman work?</button>
              {showAsk1 &&
                <div className='m-4 flex flex-col gap-4 text-secondary font-medium text-lg'>
                  <p>The Ombudsman works as follows:</p>
                  <ul>
                    <li>Receipt;</li>
                    <li>Treatment;</li>
                    <li>Reply.</li>
                  </ul>
                  <p><b>Receipt: </b> the customer sends the report on our website.</p>
                  <p><b>Treatment: </b> our team evaluates and carries out the necessary referrals regarding the report received from our website.</p>
                  <p><b>Reply: </b> the team sends the customer a response by tracking their report on the website.</p>
                </div>
              }
            </div>
            <div className='rounded-md border border-background mb-8 shadow-md'>
              <button onClick={() => setShowAsk2(!showAsk2)} className='text-2xl bg-background w-full p-4 text-start text-secondary rounded-t-md'>When will I be attended to?</button>
              {
                showAsk2 &&
                <div className='m-4 flex flex-col gap-4 text-secondary font-medium text-lg'>
                  <p>The average response time to the report received is 48 hours.</p>
                </div>
              }
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  )
};
